export { default } from './CredentialDetail';
